import { Row, Col, Typography, message } from "antd";
import React from "react";
import { StyledCheckTag } from "../../styled-components/components";
import { CloseCircleFilled } from "@ant-design/icons";
import { connect } from "react-redux";
import { removeSkills } from "../../Redux/Consultant/reducer";
import constants from "../../Redux/constants";

const SkillCard = (props) => {
  const removeSkill = async (mainId, parentId, skillId) => {
    const allSkills = props.userSkills;
    const mainSkill = allSkills.filter((skill) => skill.id === mainId);
    const requiredSubSkill = mainSkill[0].items.filter(
      (skill) => skill.id === parentId
    );
    if (requiredSubSkill[0].items.length === 1) {
      mainSkill[0].items = mainSkill[0].items.filter(
        (skill) => skill.id !== parentId
      );
    } else {
      const subSkills = requiredSubSkill[0].items.filter(
        (skill) => skill.id !== skillId
      );
      requiredSubSkill[0].items = [...subSkills];
    }
    const updatedSkills = allSkills.filter((skill) => {
      if (skill.id === mainId) {
        skill = mainSkill;
      }
      return skill;
    });
    const deletedSkillId = [skillId];
    const responseStatus = await props.removeSkills(
      deletedSkillId,
      updatedSkills
    );
    if (responseStatus === constants.status.success) {
      message.success("Skill Deleted Successfully", 3);
    }
  };
  return (
    <Col>
      {props.userSkills.map((skill) => (
        <Col>
          {skill.items.length > 0 ? (
            <Col
              key={skill.id}
              style={{
                border: "1px solid #ccc",
                margin: "1vh",
                marginBottom: "2vh",
                borderRadius: "6px",
                background: "white",
                boxShadow: "4px 4px 10px #0a4249",
              }}
            >
              <Row style={{ marginLeft: "2vh" }}>
                <Typography.Title level={4}>{skill.name}</Typography.Title>
              </Row>
              <Col>
                {skill.items &&
                  skill.items.map((item) => (
                    <Col style={{ marginLeft: "4vh" }} key={item.id}>
                      <Typography.Title level={5}>{item.name}</Typography.Title>
                      <Row>
                        {item.items &&
                          item.items.map((eachItem) => (
                            <StyledCheckTag
                              checked={true}
                              key={eachItem.id}
                              data-testid={`tag-${eachItem.id}`}
                            >
                              {eachItem.name}
                              <CloseCircleFilled
                                data-testid="submit-removeSkill"
                                onClick={() =>
                                  removeSkill(skill.id, item.id, eachItem.id)
                                }
                              />
                            </StyledCheckTag>
                          ))}
                      </Row>
                    </Col>
                  ))}
              </Col>
            </Col>
          ) : null}
        </Col>
      ))}
    </Col>
  );
};

const mapDisptachToProps = (dispatch) => {
  return {
    removeSkills: (skills, userSkills) =>
      dispatch(removeSkills(skills, userSkills)),
  };
};

export default connect(null, mapDisptachToProps)(SkillCard);
